const getters = {
    user: state => {
        return state.user;
    },

    isLogged: state => {
        return state.isLogged;
    },

    snackbar: state => {
        return state.snackbar;
    },

    car: state => {
        return state.car;
    },

    defectAct: state => {
        return state.defectAct;
    },

    defectTypes: state => {
        return state.defectTypes;
    },

    equipment: state => {
        return state.equipment;
    },

    permissions: state => {
        return state.permissions;
    },

    consumable: state => {
        return state.consumable;
    }
}

export default getters


// WEBPACK FOOTER //
// ./src/store/getters.js